import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Location } from 'history';
import withConfig from 'with-config';
import styled from 'styled-components';
import oh from 'output-helpers';
import querystring from 'querystring';

import SSO from 'sso-helper';

const Container = styled.div``;


interface AutoLoginProps {
    location: Location;
}


type Referrer = null | string;

const AutoLogin = ({ location }: AutoLoginProps) => {
    useEffect(() => {
        const config = withConfig.getCurrentConfig();

        let query = new URLSearchParams(document.location.search);
        let referrer: Referrer = document.referrer;
        if (/.*login(\.[^.]+)?\.allbin.se/.test(referrer)) {
            referrer = null;
        }

        let service = query.get('service') || 'dashboard';
        let return_url =
            query.get('return_url') ||
            query.get('returnUrl') ||
            referrer ||
            config.dashboard.url ||
            'https://dashboard.allbin.se';

        if (window.sso) {
            window.sso = null;
        }

        const options: any = {};
        if (config.api.hasOwnProperty('sso')) {
            options.token_provider_uri = config.api.sso.api_uri;
            if (location.pathname.includes('/v2')) {
                options.token_provider_uri += '/v2';
            }
        }

        window.sso = new SSO(service, options);

        Promise.resolve()
            .then(() => {
                console.log('[Login] #1: prior token');
                const prior_token = window.sso.getLastToken();
                if (!prior_token) {
                    return Promise.reject(new Error('No valid token'));
                }
                return window.sso.loginWithToken(prior_token.getRaw());
            })
            .then((token: any) => {
                if (token) {
                    window.location.href = `${return_url}?token=${token.getRaw()}`;
                    return Promise.resolve();
                }
                return Promise.reject(new Error('No valid token'));
            })
            .catch(err => {
                window.sso.clearJWT();
                window.sso.clearLastJWT();

                console.error(err.stack);
                console.log('[Login] #2: user credentials');
                setImmediate(() => {
                    window.location.href =
                        (location.pathname.includes('/v2') ? '/v2' : '/') +
                        '?' +
                        querystring.stringify({ service, return_url });
                });
            });
    }, []);

    return <Container>{oh.translate('logging_in')}</Container>;
};

export default withRouter(AutoLogin);



// WEBPACK FOOTER //
// ./src/views/AutoLogin.tsx